import React from 'react';
import UploadDocument from '../../Partials/UploadDocument';
import { useParams } from 'react-router-dom';

export default function ChatboxUpload({ onUpload, secret, privateMode }) {
  const { bookingId } = useParams();

  return (
    <UploadDocument
      bookingId={bookingId}
      onUpload={onUpload}
      secret={secret}
      privateMode={privateMode}
      loaderClass="h-5 w-5"
    >
      <svg className="h-8 w-8 text-gray-500" viewBox="0 0 384 520">
        <path d="M64 96C64 42.98 106.1 0 160 0C213 0 256 42.98 256 96V352C256 387.3 227.3 416 192 416C156.7 416 128 387.3 128 352V144C128 135.2 135.2 128 144 128C152.8 128 160 135.2 160 144V352C160 369.7 174.3 384 192 384C209.7 384 224 369.7 224 352V96C224 60.65 195.3 32 160 32C124.7 32 96 60.65 96 96V384C96 437 138.1 480 192 480C245 480 288 437 288 384V144C288 135.2 295.2 128 304 128C312.8 128 320 135.2 320 144V384C320 454.7 262.7 512 192 512C121.3 512 64 454.7 64 384V96z" />
      </svg>
    </UploadDocument>
  );
}
